import { render, staticRenderFns } from "./ProductInventoryReport.vue?vue&type=template&id=51e1e62a&"
import script from "./ProductInventoryReport.vue?vue&type=script&lang=js&"
export * from "./ProductInventoryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports